import { defineStore } from 'pinia';
import router from '@/router/index';
import StorageConst from '@/consts/storage.const';
import AdenLocalStorage from '@/utils/storage.util';
import { accountLoginRequest, getStaffId, userListInfo, userPermissions, } from '@/api/login';
import { ChainList } from '@/api/chain';
export const useLoginStore = defineStore('loginStore', {
    state: () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            token: (_a = AdenLocalStorage.get(StorageConst.STORAGE_KEY_TOKEN)) !== null && _a !== void 0 ? _a : '',
            accountId: (_b = AdenLocalStorage.get(StorageConst.STORAGE_KEY_ACCOUNT_ID)) !== null && _b !== void 0 ? _b : '',
            errorText: '',
            businessData: (_c = AdenLocalStorage.get(StorageConst.STORAGE_KEY_BUSINESS_LIST)) !== null && _c !== void 0 ? _c : [],
            expireTime: (_d = AdenLocalStorage.get(StorageConst.STORAGE_KEY_EXPIRE_TIME)) !== null && _d !== void 0 ? _d : '',
            name: (_e = AdenLocalStorage.get(StorageConst.STORAGE_KEY_USER_NAME)) !== null && _e !== void 0 ? _e : '',
            barId: (_f = AdenLocalStorage.get(StorageConst.STORAGE_KEY_BAR_ID)) !== null && _f !== void 0 ? _f : '',
            permissions: (_g = AdenLocalStorage.get(StorageConst.STORAGE_KEY_PERMISSIONS)) !== null && _g !== void 0 ? _g : [],
            openId: (_h = AdenLocalStorage.get(StorageConst.STORAGE_KEY_OPEN_ID)) !== null && _h !== void 0 ? _h : '',
            userInfo: AdenLocalStorage.get(StorageConst.STORAGE_USER_INFO),
            asst: '',
            gameLifeAccount: (_j = AdenLocalStorage.get(StorageConst.STORAGE_KEY_GAME_LIFE_ACCOUNT)) !== null && _j !== void 0 ? _j : '',
        });
    },
    actions: {
        loginStoreAccount(data, asst) {
            accountLoginRequest(data, asst).then((responseProcess) => {
                if (responseProcess.code !== 500) {
                    this.asst = asst;
                    const { access_token, name, accountId, id } = responseProcess;
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_TOKEN, access_token);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, name);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_ACCOUNT_ID, accountId);
                    // 员工登录获取员工信息
                    if (this.asst === 'asst-bar-ram-login') {
                        this.fetchStaffAccountInfo(id);
                    }
                    else if (this.asst === 'asst-bar-chain-login') {
                        this.fetchChainAccountInfo(id);
                    }
                    else {
                        // this.fetchUserPermissions();
                        this.fetchUserInfo(accountId);
                    }
                }
                else {
                    this.errorText = responseProcess.msg;
                    AdenLocalStorage.clearAll();
                }
            });
        },
        // 获取员工登录时的id
        fetchUserInfo(id) {
            const params = {
                barId: id,
            };
            userListInfo(params)
                .then((responseProcess) => {
                this.name = responseProcess.data.name;
                this.barId = responseProcess.data.id;
                this.openId = responseProcess.data.open_id;
                this.userInfo = responseProcess.data;
                this.expireTime = responseProcess.data.expire_time;
                AdenLocalStorage.set(StorageConst.STORAGE_USER_INFO, responseProcess.data);
                AdenLocalStorage.set(StorageConst.STORAGE_KEY_GAME_LIFE_ACCOUNT, responseProcess.data.game_life_account);
                AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.id);
                AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
                AdenLocalStorage.set(StorageConst.STORAGE_KEY_OPEN_ID, responseProcess.data.open_id);
                AdenLocalStorage.set(StorageConst.STORAGE_KEY_EXPIRE_TIME, responseProcess.data.expire_time);
            })
                .then(() => {
                this.fetchUserPermissions();
            });
        },
        fetchStaffAccountInfo(id) {
            getStaffId(id).then((responseProcess) => {
                if (responseProcess.code === 200) {
                    if (this.asst === 'asst-bar-chain-login') {
                        AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID, responseProcess.data.id);
                    }
                    else {
                        AdenLocalStorage.clear(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID);
                    }
                    this.userInfo = responseProcess.data;
                    AdenLocalStorage.set(StorageConst.STORAGE_USER_INFO, responseProcess.data);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.bar_id);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
                    this.name = responseProcess.data.name;
                    this.fetchUserPermissions();
                }
            });
        },
        fetchChainAccountInfo(id) {
            ChainList(id).then((responseProcess) => {
                if (responseProcess.code === 200 && responseProcess.data) {
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_CHAIN_ID, responseProcess.data.id);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_BAR_ID, responseProcess.data.bar_id);
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_USER_NAME, responseProcess.data.name);
                    this.name = responseProcess.data.name;
                    this.fetchUserPermissions();
                }
            });
        },
        // 获取用户对应的权限
        fetchUserPermissions() {
            const typeMapping = {
                'asst-business-system': 0,
                'asst-bar-ram-login': 2,
                'asst-bar-chain-login': 1, // 连锁
            };
            const type = typeMapping[this.asst] !== undefined ? typeMapping[this.asst] : null;
            userPermissions({ type: type }).then((responseProcess) => {
                if (responseProcess.code === 200) {
                    this.permissions = responseProcess.data;
                    AdenLocalStorage.set(StorageConst.STORAGE_KEY_PERMISSIONS, this.permissions);
                    const redirectMapping = {
                        'asst-business-system': { storageValue: 'business', route: '/business/main' },
                        'asst-bar-ram-login': { storageValue: 'staff', route: '/staff/main' },
                        'asst-bar-chain-login': { storageValue: 'chain', route: '/business/chain' },
                    };
                    const redirectInfo = redirectMapping[this.asst];
                    if (redirectInfo && this.token === '') {
                        router.push(redirectInfo.route).then();
                        AdenLocalStorage.set(StorageConst.STORAGE_KEY_LOGIN_TYPE, redirectInfo.storageValue);
                    }
                }
            });
        },
        clearErrorText() {
            this.errorText = '';
        },
        // 清除登录信息
        clearLoginInfo() {
            this.token = '';
            this.accountId = '';
            this.errorText = '';
            this.businessData = [];
            this.expireTime = '';
            this.name = '';
            this.barId = '';
            this.permissions = [];
            this.openId = '';
            this.asst = '';
        },
    },
});
